import React from 'react';
import { ageCoverage } from '../data/content';
const metrics = [{
  value: '400+',
  label: 'PAGES'
}, {
  value: '208',
  label: 'PRACTICE WEEKS'
}, {
  value: '100+',
  label: 'DRILLS'
}, {
  value: '5',
  label: 'AGE CATEGORIES'
}];
export function SystemOverview() {
  return <section className="border-b border-line bg-ink py-16 md:py-24" aria-labelledby="system-title" data-id="element-183" data-mp="1hnknxtf33jqb">
      <div className="mx-auto max-w-5xl px-5 text-center md:px-8" data-id="element-184" data-mp="ty0292rjq8dc">
        <p className="font-display text-lg font-bold uppercase tracking-[0.16em] text-accent md:text-xl" data-id="element-185" data-mp="ty9u6vw5iplo">
          The complete system to stop improvising baseball training
        </p>
        <h2 id="system-title" className="mt-4 font-display text-6xl font-extrabold uppercase leading-none text-white md:text-8xl" data-id="element-186" data-mp="13xqzhc7hr1h4">
          Baseball 360™
        </h2>
        <p className="mt-3 font-display text-2xl font-bold uppercase tracking-wide text-white md:text-4xl" data-id="element-187" data-mp="2f9rsj3be1c2o">
          15 Volumes + 6 Bonuses
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-188" data-mp="236mfceqf8yw5">
          Over 400 pages. 208 structured practice weeks. 100+ professional drills. Biomechanics.
          Tactical scenarios. Player assessment. Team management. Everything ready. Everything
          organized. Everything yours for life.
        </p>

        <dl className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-line bg-line md:grid-cols-4" data-id="element-189" data-mp="2i2vfrjm1tia5">
          {metrics.map(metric => <div key={metric.label} className="bg-ink-800 px-4 py-6" data-id="element-190" data-mp="1pe6d3g5ch4wa">
              <dd className="font-display text-4xl font-extrabold text-white md:text-5xl" data-id="element-191" data-mp="1ue2cf233k85i">
                {metric.value}
              </dd>
              <dt className="mt-1 text-[11px] font-semibold tracking-[0.14em] text-slate-400" data-id="element-192" data-mp="1z5kgw04bwqv8">
                {metric.label}
              </dt>
            </div>)}
        </dl>

        <div className="mt-14" data-id="element-193" data-mp="16nonvljq0rfo">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400" data-id="element-194" data-mp="16mn9p87erotq">
            Full coverage · Every age group
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-3" data-id="element-195" data-mp="tp8pofvi7jb5">
            {ageCoverage.map(group => <li key={group} className="rounded-full border border-line bg-ink-800 px-4 py-2 text-sm font-semibold text-slate-200" data-id="element-196" data-mp="18dv50hl4sb2d">
                {group}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}